import { render, staticRenderFns } from "./IdListText.vue?vue&type=template&id=10d490bd&scoped=true&"
import script from "./IdListText.vue?vue&type=script&lang=js&"
export * from "./IdListText.vue?vue&type=script&lang=js&"
import style0 from "./IdListText.vue?vue&type=style&index=0&id=10d490bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d490bd",
  null
  
)

export default component.exports